<template>
  <div class="page page-about">
    <section class="section">
      <div class="section-inner">
        <div class="section-header">
          <h2 class="section-title">公司介绍</h2>
          <p class="section-subtitle">专注企业数字化转型的一体化服务提供商。</p>
        </div>
        <div class="about-body">
          <p>
            某某科技长期深耕企业服务领域，围绕协同办公、智能分析、客户关系管理等关键场景，
            输出咨询规划、产品交付、运维运营在内的全生命周期服务。
          </p>
          <p>
            我们坚持“以客户价值为中心”的理念，联合生态合作伙伴，帮助不同行业的企业完成组织与业务的数字化升级，
            提升效率、优化决策、驱动创新。
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.page {
  background: #f5f7fa;
}

.about-body {
  background: #ffffff;
  border-radius: 18px;
  padding: 24px 24px 26px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.1);
  font-size: 14px;
  color: #52606d;
  line-height: 1.9;
}

.about-body p + p {
  margin-top: 10px;
}
</style>

